package de.katoonerie.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div

@Composable
fun Glasspane(doClose: () -> Unit, hideIf: () -> Boolean) {
    Div(attrs = {
        classes("fixed", "top-0", "left-0", "right-0", "bottom-0", "bg-[#000a]")
        onClick { doClose() }
        style {
            if (hideIf()) {
                display(DisplayStyle.None)
            }
        }
    })
}

@Composable
fun GlasspaneCloseButton(doClose: () -> Unit, hideIf: () -> Boolean) {
    Button(attrs = {
        classes("rounded-full", "bg-black", "border-amber-50", "border-4", "color-amber-50", "w-16", "h-16", "fixed", "right-0", "top-0", "sm:right-5", "sm:top-5", "p-1")
        onClick { doClose() }
        style {
            if (hideIf()) {
                display(DisplayStyle.None)
            }
        }
    }) {
        XMark()
    }
}
